import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import "./Homepage.scss";
import HomepageIncentives from "./components/HomepageIncentives";
import getLocalVehicles from "../../../functions/vehicle/getLocalVehicles";
import ShuffleFlatArray from "../../../utils/Helpers/ShuffleFlatArray";
import VehiclesCarousel from "../../../components/VehicleCarousel/VehicleCarousel";
import ChargingMap from "../../../components/LocationMap/ChargingMap";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";

import homePageBannerImage from "../../assets/images/homeBanner.svg";
import homePageTextImage from "../../assets/images/yourGuide.svg";
import HomepageBigPromise from "./components/HomepageBigPromise";

import cardImage1 from "../../assets/images/cardImage1.svg";
import cardImage2 from "../../assets/images/cardImage2.svg";
import cardImage3 from "../../assets/images/cardImage3.svg";
import cardImage4 from "../../assets/images/cardImage4.svg";
import cardImage1hover from "../../assets/images/cardImage1red.svg";
import cardImage2hover from "../../assets/images/cardImage2red.svg";
import cardImage3hover from "../../assets/images/cardImage3red.svg";
import cardImage4hover from "../../assets/images/cardImage4red.svg";

const Homepage = ({ electricVehicles, incentives, userLocation, ip, uuid }) => {
  const [vehicles, setVehicles] = useState([]);

  const [carOver, setCarOver] = useState(false);
  const [compareOver, setCompareOver] = useState(false);
  const [chargingOver, setChargingOver] = useState(false);
  const [incentivesOver, setIncentivesOver] = useState(false);
  const setElectricVehicles = () => {
    if (electricVehicles) setVehicles(ShuffleFlatArray(electricVehicles));
  };

  useEffect(() => {
    setElectricVehicles();
  });

  const renderDetails =
    electricVehicles && incentives ? (
      <>
        <VehiclesCarousel electricVehicles={getLocalVehicles(vehicles)} />
        <HomepageIncentives incentives={incentives} />
      </>
    ) : (
      <section className="container">
        <LoadingSpinner />
      </section>
    );

  return (
    <>
      <HomepageBigPromise
        homePageBannerImage={homePageBannerImage}
        homepageTextImage={homePageTextImage}
      />

      <div className="cardRow">
        <a
          className="card"
          href="/used-vehicles"
          onMouseOver={() => setCarOver(true)}
          onMouseOut={() => setCarOver(false)}
        >
          <div className="imgContainer">
            <img
              src={carOver ? cardImage1hover : cardImage1}
              alt="doordash nav icon cardImage1"
            />
          </div>
          <p>Browse All EVs</p>
        </a>

        <a
          className="card"
          href="/compare-vehicles-used"
          onMouseOver={() => setCompareOver(true)}
          onMouseOut={() => setCompareOver(false)}
        >
          <div className="imgContainer">
            <img
              src={compareOver ? cardImage2hover : cardImage2}
              alt="doordash nav icon cardImage2"
            />
          </div>
          <p>Compare Vehicles</p>
        </a>

        <a
          className="card"
          href="/charging-stations"
          onMouseOver={() => setChargingOver(true)}
          onMouseOut={() => setChargingOver(false)}
        >
          <div className="imgContainer">
            <img
              src={chargingOver ? cardImage3hover : cardImage3}
              alt="doordash nav icon cardImage3"
            />
          </div>
          <p>Find Charging Stations</p>
        </a>

        <a
          className="card"
          href="/incentives"
          onMouseOver={() => setIncentivesOver(true)}
          onMouseOut={() => setIncentivesOver(false)}
        >
          <div className="imgContainer">
            <img
              src={incentivesOver ? cardImage4hover : cardImage4}
              alt="doordash nav icon cardImage4"
            />
          </div>
          <p>Discover Incentives</p>
        </a>
      </div>

      <div className="textRow">
        <h1>There are more electric vehicles than ever. Discover yours.</h1>
        <p>
          Compare the cost of your selection to a similar gas vehicle. An EV can
          save you money because it can be cheaper to own and maintain than a
          100% gasoline-powered car.
        </p>
        <a className="btn" href="/used-vehicles">
          Find Your EV
        </a>
      </div>

      {renderDetails}

      <div id="HomepageChargingStations">
        <div className="container">
          <div className="textContainer">
            <h2>Recharge on the go, wherever you go.</h2>
            <p>
              With new stations powering on every day, it’s easier than ever to
              drive far and recharge. Enter your location to see all of the
              charging stations near you.
            </p>
          </div>

          <ChargingMap hideList userLocation={userLocation} />
        </div>
      </div>
    </>
  );
};

export default Homepage;

Homepage.propTypes = {
  homePageBannerImage: PropTypes.string,
  electricVehicles: PropTypes.array,
  incentives: PropTypes.array,
  ip: PropTypes.string,
  uuid: PropTypes.string,
};
